// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1506":"d23a2076","2409":"48401bb8","3102":"9c76787a","3791":"cc709781","5107":"6ed08e7b","9135":"151d0a7f","9664":"9fa42e33"}[chunkId] + ".chunk.css";
};